import { TForeignTradeByCountriesState } from './types';

export function setCountryAggregated(
  state: TForeignTradeByCountriesState,
  data: TForeignTradeByCountriesState['countryAggregated'],
) {
  state.countryAggregated = data;
}
